import React, {Component} from "react";
import "./UserProfile.css";
import "../../Common/Common.css";
import UserProfileInfo from "./UserProfileInfo/UserProfileInfo";
import UserAddressTable from "./UserAddressTable/UserAddressTable";
import {FormattedMessage} from "react-intl";
import {BASE_URL, GOOGLE_ANALYTICS_CODE, IS_IN_MOBILE_MODE, RESOURCE_BASE_URL} from '../../../configuration';
import axios from 'axios';
import GoogleAds from "../../Common/GoogleAds/GoogleAds";
import UserProfileNavBar from "./UserProfileNavBar";
import ReactGA from "react-ga";
import {Link} from "react-router-dom";
import Modal from "react-bootstrap/lib/Modal";

class UserProfile extends Component {

    constructor(props) {
        super(props);

        this.state = {
            userId: "",
            userAddresses: [],
            userInfo: {}
        };

        this.getUserAddresses = this.getUserAddresses.bind(this);
        this.getUserDetails = this.getUserDetails.bind(this);
    }

    getUserAddresses = (userId) => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/' + userId + '/addresses', axiosConfig)
            .then((res) => {
                // console.log('addresses------>', res.data);
                this.setState({
                    userAddresses: res.data
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    getUserDetails = (userId) => {
        let tokenString;
        if (localStorage.getItem("userRole") === "ROLE_IMPERSONATE") {
            tokenString = localStorage.getItem("newTokenString");
        } else {
            tokenString = localStorage.getItem("tokenString")
        }
        let axiosConfig = {
            headers: {
                'Authorization': tokenString.toString()
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.userId, axiosConfig)
            .then((res) => {
                console.log('userInfo in profile ------>', res.data);
                this.setState({
                    userInfo: res.data
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                console.log("Token invalid");
                localStorage.clear();
                window.location.replace(BASE_URL + "login");
            });
    };

    componentDidMount() {
        console.log("user profile user id ===> " + this.props.userId)
        if (this.props.userData && this.props.userId) {
            this.setState({userId: this.props.userId});
            this.getUserDetails(this.props.userId);
            this.getUserAddresses(this.props.userId);
        }
        console.log("props.UserId ====> " + this.props.userId);
    }

    /*componentDidMount() {
    }*/

    componentDidUpdate(prevProps, prevState, snapshot) {
        console.log("user profile user id ===> " + this.props.userId)
        if (prevProps.userData !== this.props.userData) {
            this.setState({userId: this.props.userId});
            this.getUserDetails(this.props.userId);
            this.getUserAddresses(this.props.userId);
        }
    }

    render() {
        ReactGA.initialize(GOOGLE_ANALYTICS_CODE);
        ReactGA.pageview(window.location.pathname + window.location.search);
        // if (this.props.userData != null && localStorage.getItem("userRole") !== "ROLE_IMPERSONATE") {
            // console.log(this.state.userInfo);
            return (
                <div className="">

                    <div className="row collapse-user-profile-div">
                        <UserProfileNavBar userData={this.props.userData}
                                           userInfo={this.state.userInfo}
                                           userId={this.props.userId}
                                           getUserDetails={this.getUserDetails}/>
                    </div>
                <div className="shopping-cart-content">
                    <GoogleAds slot="696274611"/>
                    <div className="shopping-cart-div1">
                        <div className="container-fluid">

                            <div className="row">
                                <div className="title-1">
                                    <FormattedMessage id="app.user-profile.title"
                                                      defaultMessage="USER PROFILE"
                                                      description=""
                                    />
                                </div>
                                <hr/>
                            </div>

                            <div className="row">
                                <UserProfileInfo userInfo={this.state.userInfo}
                                                 getUserDetails={this.getUserDetails}
                                                 userData={this.props.userData}
                                                 userId={this.props.userId}/>
                                <div className="spacer"></div>
                            </div>
                            <div className="row">
                                <UserAddressTable userInfo={this.state.userInfo}
                                                  userAddresses={this.state.userAddresses}
                                                  getUserAddresses={this.getUserAddresses}
                                                  getUserDetails={this.getUserDetails}
                                                  userData={this.props.userData}
                                                  userId={this.state.userId}/>
                                <div className="spacer"></div>
                            </div>

                        </div>
                    </div>
                </div>
                </div>
            );
        // } else {
        //         return (
        //         <Modal dialogClassName="special-character-modal modal-center1" show={true}>
        //             <Modal.Body class="modal-body">
        //                 <div className="row">
        //                     <div className="modal-dialog center">
        //                         アクセスが拒否されました
        //                     </div>
        //                 </div>
        //             </Modal.Body>
        //             <Modal.Footer class="modal-footer">
        //                 <Link to="/order/all">
        //                     <button className="btn btn-success col-md-2 pull-right delete-btn-yes btn-align">
        //                         <FormattedMessage id="app.modal.close"
        //                                           defaultMessage="No"
        //                                           description=""/>
        //                     </button>
        //                 </Link>
        //             </Modal.Footer>
        //         </Modal>);
        // }


    }

}

export default UserProfile;



// WEBPACK FOOTER //
// ./src/components/Site/UserProfile/UserProfile.js